import React, { useEffect, useState } from "react";
import "./BranchAnalysts.scss";
import { useSelector } from "react-redux";
import LineChart from "../Charts/LineChart/LineChart";

const colors = ["#092B3A", "#65C1E8", "#C1E6F6", "#DCF2FB", "#115774"];

const BranchAnalysts = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);

  const { branchAnalytics: branchAnalystsData } = useSelector(
    (state) => state.analyticsReducer
  );

  const [totalData, setTotalData] = useState({
    total_revenue: 0.0,
    total_sales: 0,
  });

  const [data, setData] = useState({
    labels: [],

    datasets: [
      {
        label: "Revenue",
        data: [],
        backgroundColor: "#65C1E8",
        borderColor: "#65C1E8",
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSets = [];

    let temp_total_revenue = 0;
    let temp_total_sales = 0;

    branchAnalystsData?.revenue_by_branch?.forEach((el, index) => {
      const dataSet = [];

      temp_total_revenue += el?.revenue || 0;
      temp_total_sales += el?.sales || 0;

      el?.revenue_per_day?.map((rev) => {
        const alreadyExists = labels.find((el) => el === rev?.day);
        if (!alreadyExists) {
          labels.push(rev?.day);
        }
        dataSet.push(rev?.revenue);
      });

      const colorIndex = index % colors.length;
      dataSets.push({
        label: el?.name || "N/A",
        data: dataSet,
        backgroundColor: colors[colorIndex],
        borderColor: colors[colorIndex],
      });
    });

    setTotalData({
      total_revenue: Number(temp_total_revenue).toFixed(2),
      total_sales: temp_total_sales,
    });

    setData({
      labels: labels,
      datasets: dataSets,
    });
  }, [branchAnalystsData]);

  return (
    <div className="branches-analytics">
      <div className="container-wrapper branches">
        <p className="heading">Branches Revenue Graph</p>

        <div className="sales-chart">
          <div className="title-list">
            {/* <p className="table-head">Hourly</p>
            <p className="table-head">Day</p>
            <p className="table-head">Week Day</p> */}
          </div>

          <div className="chart-container">
            <p className="chart-title">
              <span>Total:</span> {currency}
              {branchAnalystsData?.best_branch?.revenue || "0.00"}
            </p>
            <LineChart data={data} currency={currency} />
          </div>

          <div className="chart-labels">
            {branchAnalystsData?.revenue_by_branch?.map((el, i) => {
              return (
                <div className="label" key={i}>
                  <span
                    className="dot"
                    style={{
                      backgroundColor: `${colors[i]}`,
                    }}
                  ></span>
                  <p>{el?.name || 'N/A'}</p>
                </div>
              );
            })}
          </div>
        </div>

        <p className="heading">Branch Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>Name</p>
            <p>Revenue</p>
            <p>Purchase</p>
            <p>Purchase %</p>
          </div>

          <div className="table-body">
            {branchAnalystsData?.revenue_by_branch?.map((el, i) => {
              return (
                <div className="row" key={i}>
                  <p>{el?.name || "N/A"}</p>
                  <p className="price">
                    {currency}
                    {Number(el?.revenue).toFixed(2) || "0.00"}
                  </p>
                  <p className="sales-font">{el?.sales || 0}</p>
                  <p>
                    {Number(
                      (el?.sales / totalData.total_sales) * 100
                    ).toFixed(2)}
                    %
                  </p>
                </div>
              );
            })}

            <div className="row total">
              <p>Total</p>
              <p>
                {currency}
                {totalData.total_revenue || "0.00"}
              </p>
              <p>{totalData.total_sales || 0}</p>
              <p>{totalData.total_revenue ? "100%" : "0%"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchAnalysts;
